<template>
  <div>
    <router-tabs :links="links">
      <router-view class="pt-4" />
    </router-tabs>
  </div>
</template>
<script>
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import RouterTabs from '@/components/utils/RouterTabs.vue';

export default {
  components: {
    RouterTabs,
  },
  setup() {
    const { t } = useI18n();
    const links = ref([
      { id: 'tab-discounts', text: t('discount.label', 2), route: { name: 'discounts' } },
      { id: 'tab-promotions', text: t('promotion.label', 2), route: { name: 'promotions' } },
    ]);

    return {
      links,
    };
  },
};
</script>
